import {Component, Input} from '@angular/core';

@Component({
  selector: 'nc-pdf-viewer',
  templateUrl: './nc-pdf-viewer.component.html',
  styleUrls: ['./nc-pdf-viewer.component.scss']
})
export class NcPdfViewerComponent {
  @Input() url: string;
  @Input() language: string;
  @Input() fileName: string;
  @Input() token: string;
}
